import PropTypes from "prop-types";
import { Input, Modal, ModalBody } from "reactstrap";
import "./chatModals.scss";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import { useState } from "react";
import productImg from "../../../assets/images/product.png";
import delivery from "../../../assets/images/delivery.png";
import emoji from "../../../assets/images/emoji.png";

const ChatSelectOrderModal = ({
  show,
  onCloseClick,
  productData,
  handleSendOrder,
}: any) => {
  const [selectedProducts, setSelectedProducts] = useState<any>({});
  const [quantities, setQuantities] = useState<any>({});

  const toggleProductSelection = (product: any) => {
    setSelectedProducts((prev: any) => ({
      ...prev,
      [product.id]: !prev[product.id],
    }));
  };

  const handleQuantityChange = (productId: string, delta: number) => {
    setQuantities((prev: any) => ({
      ...prev,
      [productId]: Math.max((prev[productId] || 1) + delta, 1),
    }));
  };

  const handleSend = (product: any) => {
    const qty = quantities[product.id] || 1;
    const payload = {
      ...product,
      buypassId: product.buypassId,
      quantity: qty,
      type: "product",
    };
    handleSendOrder(payload);
    onCloseClick();
  };

  return (
    <Modal
      isOpen={show}
      toggle={onCloseClick}
      centered
      className="smallChatModal"
    >
      <img
        data-testing-id="closeIcon"
        onClick={onCloseClick}
        className="closeIconModal"
        src={CLoseImg}
        alt=""
      />
      <ModalBody className="chatSeelctBody">
        <h2 className="headingDv">Select Products</h2>
        {productData?.map((productItem: any, index: number) => {
          const isSelected = selectedProducts[productItem.id];
          const quantity = quantities[productItem.id] || 1;

          return (
            <div className="selectCardDv" key={productItem.id || index}>
              {/* <Input
                  type="checkbox"
                  checked={isSelected || false}  
                  onChange={() => toggleProductSelection(productItem)}
                  className="form-check-input rounded-circle mt-0"
                /> */}
              <div className="selectContentDv">
                <div className="orderDv">
                  <figure>
                    <img
                      src={productItem.image || productImg}
                      className="proDuct"
                      alt=""
                    />
                  </figure>
                  {/* <div className="conPlusMin">
                    <div
                      className="plusMinDV"
                      onClick={() => handleQuantityChange(productItem.id, -1)}
                    >
                      <i className="bx bx-minus"></i>
                    </div>
                    <div className="countDV">{quantity}</div>
                    <div
                      className="plusMinDV"
                      onClick={() => handleQuantityChange(productItem.id, 1)}
                    >
                      <i className="bx bx-plus"></i>
                    </div>
                  </div> */}
                </div>

                <div className="dataContentDv">
                  <div className="dataDv">
                    <h4>{productItem.nameEn}</h4>
                    <p>{productItem.category}</p>
                    <div className="priceDv">
                      <h3>
                        <span>Rs.</span> {productItem.price}
                      </h3>
                    </div>
                    <div className="deliveryDv">
                      <div className="del">
                        <img src={delivery} alt="" />
                        <h4>Free Delivery</h4>
                      </div>
                      <div className="border"></div>
                      <h4>
                        Deliver in <span>2h 30m</span>
                      </h4>
                    </div>
                    <h3>
                      <span>
                        <img src={emoji} alt="" />
                      </span>{" "}
                      {`Last ${productItem?.stock}  items`}
                    </h3>
                  </div>
                  <button
                    className="btn sedBtn"
                    onClick={() => handleSend(productItem)}
                    data-testing-id={"SendItems" + index}
                    // disabled={!isSelected}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </ModalBody>
    </Modal>
  );
};

ChatSelectOrderModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  handleSendOrder: PropTypes.func,
  productData: PropTypes.any,
};

export default ChatSelectOrderModal;
